<template>
 <v-dialog
  style="border-radius: 10px;"
  v-model="dialog"
  width="500"
>
  <v-card v-if="dialog"  class="px-2 py-3">
    <v-card-title class="pa-1">
      <span class="font-weight-bold headline wrld_subtitle--text">
       {{ isEditing ? $t('locations.edit_location') : $t('locations.add_location') }}
      </span>
    </v-card-title>
    <v-card-text class="pa-1">
      <v-container v-if="!isEditing" class="pb-0">
        <v-form v-model="isValidLocationNameType">
          <v-row>
            <v-col cols="12" sm="6" md="12">
            <v-text-field class="wrld_subtitle--text" :label="$t('locations.location_name')" v-model="name"
            :rules="[]"
            >

            </v-text-field>
          </v-col>
          <v-col cols="12" sm="6" md="12">
            <v-select
              :disabled="isHQEdit"
              :items="computedLocationsAvailableTypes"
              :item-text="(item) => ($t(`locations.${item.name}`))"
              :item-value="'name'"
              v-model="type"
              :rules="[Required]"
              :label="`${$t('locations.type')}`"
            ></v-select>
          </v-col>
          </v-row>
        </v-form>
      </v-container>
      <LocationAutocomplete
      :key="locationAutocompleteKey"
      :isEditing="isEditing"
      :editableAddress="editableAddress"
      :editableCoordinates="editableCoordinates"
      @address="(newAddress) => address = newAddress"
      @coordinates="(newCoordinates) => coordinates = newCoordinates"
      @is-valid="(validLocation) => isValid = validLocation"
      :isEditingCoordinates="isEditingCoordinates"
      :isEditingHQ="isHQEdit"
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="wrld-background elevation-1" @click="handleCancelLocation"> <span color="wrld_subtitle--text">{{$t('buttons.cancel')}}</span> </v-btn>
      <v-btn v-if="!isLoadingAddingLocation" color="accent elevation-1" class="ml-5 mr-4" :disabled="computedFormValidation"  @click="handleCreateLocation">
        {{ isEditing ? $t('buttons.save') : $t('buttons.create') }}
        </v-btn>
      <v-btn v-else color="accent elevation-1" class="ml-5 mr-4" disabled>
        <v-progress-circular
          size="20"
          width="3"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</template>

<script>
import { uuid } from 'vue-uuid'
import { Required, CoordinatesRule } from '@/plugins/form-validations.js'
import { locationService } from '@/_services'
import { mapActions } from 'vuex'
import LocationAutocomplete from '@/components/organizations/locations/LocationAutocomplete'

export default {
  name: 'AddLocation',
  components: {
    LocationAutocomplete
  },
  props: {
    openMenu: { type: Boolean, default: false },
    editableAddress: { type: Object, default: () => null },
    editableCoordinates: { type: Object, default: () => null },
    editableAddressName: { type: String, default: null },
    editableAddressType: { type: String, default: null },
    isEditing: { type: Boolean, default: false },
    isHQEdit: { type: Boolean, default: false },
    isEditingCoordinates: {type: Boolean, default: true},
    orgID: { type: String, default: null } 
  },
  data () {
    return {
      Required,
      CoordinatesRule,
      isLoadingAddingLocation: false,
      dialog: false,
      isValid: false,
      isValidLocationNameType: false,
      locationAutocompleteKey: uuid.v1(),
      isLoading: false,
      name: null,
      type: null,
      address: {
        street: null,
        streetNo: null,
        city: null,
        countryCode: null,
        postalCode: null
      },
      coordinates: {
        lat: null,
        lng: null
      },
      locationsAvailableTypes: null
    }
  },
  mounted () {
    locationService.getLocationTypeEnum().then((response) => {
      this.locationsAvailableTypes = response
    })
    if (this.isHQEdit) {
      this.name = this.editableAddressName
      this.type = this.editableAddressType
    }
    if (this.editableAddress !== null && this.isEditing) {
      this.isManual = true
      this.isValidLocationNameType = true
      this.address = { ...this.editableAddress }
      this.$nextTick(() => {
        this.coordinates = { ...this.editableCoordinates }
      })
    }
  },
  methods: {
    ...mapActions({
      showSnackbar: 'showSnackbar',
      addSecondResourceOverviewListItem: 'addSecondResourceOverviewListItem'
    }),
    handleCreateLocation () {
      if (this.isHQEdit) {
        this.$emit('location-hq-edited', { address: { ...this.address }, coordinates: { ...this.coordinates }, name: this.name })
        this.$nextTick(() => {
          this.dialog = false
          this.locationAutocompleteKey = uuid.v1()
          // this.$refs['createLocationForm'].reset()
        })
      } else if (!this.isEditing) {
        this.isLoadingAddingLocation = true
        locationService.createLocation({
          organization: this.orgID === null ? this.$route.params.organizationID : this.orgID,
          type: this.type,
          coordinates: this.coordinates,
          name: this.name,
          address: this.address
        }).then((response) => {
          this.addSecondResourceOverviewListItem({
            item: {
              id: response.id,
              type: this.type,
              name: this.name,
              address: { ...this.address },
              coordinates: { ...this.coordinates },
              equipment: null,
              accessibility: null,
              ref: null
            }
          })
          this.$emit('location-added')
          this.$nextTick(() => {
            this.dialog = false
            // this.$refs['createLocationForm'].reset()
          })
          this.showSnackbar({ message: this.$t('snackbars.location_created'), color: 'success' })
        }).catch((error) => {
          this.showSnackbar({ message: this.$i18n.t('snackbars.error'), color: 'error' })
          console.error(error)
        }).finally(() => {
          this.isLoadingAddingLocation = false
        })
      } else {
        this.$emit('location-edited', { address: { ...this.address }, coordinates: { ...this.coordinates } })
        this.$nextTick(() => {
          this.dialog = false
          this.locationAutocompleteKey = uuid.v1()
          // this.$refs['createLocationForm'].reset()
        })
      }
    },
    handleCancelLocation () {
      this.search = ''
      this.isManual = false
      this.dialog = false
      this.suggestions = []
      this.searchManual = ''
      this.suggestionsManual = []
      this.locationAutocompleteKey = uuid.v1()
      // this.$refs['createLocationForm'].reset()
    }
  },
  computed: {
    customAddress () {
      if (this.isManual) {
        return this.$options.filters.AddressObjectToString(this.address, [['street', 'streetNo'], 'postalCode', ['city', 'countryCode']])
      } else {
        return ''
      }
    },
    computedFormValidation () {
      if (this.isHQEdit) {
        return !this.isValid
      }
      return !(this.isValid && this.isValidLocationNameType)
    },
    computedLocationsAvailableTypes () {
      return this.locationsAvailableTypes
    }
  },
  watch: {
    openMenu: {
      handler: function (val, oldVal) {
        this.dialog = val
      }
    },
    dialog: {
      handler: function (val, oldVal) {
        if (!val) {
          this.search = ''
          this.isManual = false
          this.suggestions = []
          this.searchManual = ''
          this.suggestionsManual = []
          this.locationAutocompleteKey = uuid.v1()
          this.$emit('close')
          // this.$refs['createLocationForm'].reset()
        }
      }
    }
  },
  beforeDestroy () {
    this.$emit('close')
  }
}
</script>

<style lang="scss" scoped>
.lock-button {
  pointer-events: auto;
}
</style>
